import { render, staticRenderFns } from "./TabelaCadastro.vue?vue&type=template&id=79a292f1"
import script from "./TabelaCadastro.vue?vue&type=script&lang=js"
export * from "./TabelaCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports